module.exports = __webpack_public_path__ + "img/ico-check-blue-quest.1c6f7c19.svg";